export default "/public/dist/img/logo@2x.png";